export const es: Record<string, string> = {
  // Navbar
  'navbar.products': 'Productos',
  'navbar.useCases': 'Casos de uso',
  'navbar.pricing': 'Precios',
  'navbar.about': 'Nosotros',
  'navbar.contact': 'Contacto',
  'navbar.bookDemo': 'Reservar una demo',
  'navbar.tripppMap': 'Trippp Map',
  'navbar.tripppSpark': 'Trippp Spark',
  'navbar.tripppTripOps': 'Trippp Ops',
  'navbar.dmosAndTourismBoards': 'OGD y Oficinas de turismo',
  'navbar.dmcsAndTravelAgencies': 'DMC y Agencias de viaje',
  'navbar.hotelsAndResorts': 'Hoteles y Resorts',
  'navbar.realEstateAndLifestyle': 'Inmobiliaria y Lifestyle',

  // Hero
  'hero.title': 'Impulsa el viaje completo',
  'hero.subtitle':
    'La plataforma tecnológica modular para el turismo que impulsa todo, desde el primer deseo hasta el último día sobre el terreno.',
  'hero.bookDemo': 'Reservar una demo',
  'hero.exploreProducts': 'Explorar productos',

  // Social Proof
  'socialProof.trusted':
    'Destinos y agencias de todo el mundo confían en nosotros',

  // Product Suite
  'productSuite.title': 'Una plataforma. Tres productos.',
  'productSuite.subtitle':
    'Arquitectura modular diseñada para escalar con tu negocio turístico.',
  'productSuite.learnMore': 'Saber más',
  'productSuite.mapName': 'Trippp Map',
  'productSuite.mapDesc':
    'Un mapa interactivo de destino en marca blanca. Puntos de interés, itinerarios, rutas de senderismo y contenido multilingüe — todo gestionado a través de un CMS dedicado.',
  'productSuite.sparkName': 'Trippp Spark',
  'productSuite.sparkDesc':
    'Una experiencia de descubrimiento cinematográfica basada en emociones. Los viajeros exploran un destino emocionalmente antes de reservar un vuelo.',
  'productSuite.opsName': 'Trippp Ops',
  'productSuite.opsDesc':
    'Una app para viajeros y plataforma operativa en uno. En marca blanca por viaje, ofrece a los viajeros su programa completo mientras da a las agencias visibilidad total sobre extras y comisiones.',

  // Persona Tabs
  'personaTabs.sectionTitle': 'Diseñado para tu industria.',
  'personaTabs.tab0Label': 'OGD y Oficinas de turismo',
  'personaTabs.tab1Label': 'DMC y Agencias de viaje',
  'personaTabs.tab2Label': 'Hoteles y Resorts',
  'personaTabs.tab3Label': 'Promotores inmobiliarios y Lifestyle',
  'personaTabs.content0Title':
    'Pon tu destino en el mapa digital — literalmente.',
  'personaTabs.content0Desc':
    'Ofrece a los visitantes una ventana interactiva y multilingüe a todo lo que tu región ofrece. Desde senderos ocultos hasta itinerarios seleccionados, Trippp Map y Spark convierten cualquier destino en una experiencia digital de clase mundial — completamente con tu marca.',
  'personaTabs.content0Feature0': 'Mapa interactivo de destino con CMS',
  'personaTabs.content0Feature1':
    'Experiencia de descubrimiento cinematográfica',
  'personaTabs.content0Feature2':
    'Multilingüe — impulsado por IA, cualquier idioma',
  'personaTabs.content1Title':
    'Operaciones más eficientes. Más mandatos internacionales.',
  'personaTabs.content1Desc':
    'Trippp Ops ofrece a tu agencia una app para viajeros en marca blanca para cada operación — marketplace de extras, documentos, programa, contactos de emergencia. Los socios internacionales te eligen porque ofreces una transparencia en la que pueden confiar.',
  'personaTabs.content1Feature0': 'App para viajeros en marca blanca por viaje',
  'personaTabs.content1Feature1': 'Marketplace de extras y comisiones',
  'personaTabs.content1Feature2': 'Visibilidad operativa en tiempo real',
  'personaTabs.content2Title':
    'Muestra a tus huéspedes lo que les rodea antes de llegar.',
  'personaTabs.content2Desc':
    'Integra Spark directamente en tu sitio web. Deja que los futuros huéspedes exploren tu propiedad y el destino que la rodea a través de una experiencia cinematográfica que ninguna galería estática puede igualar.',
  'personaTabs.content2Feature0': 'Experiencia cinematográfica integrable',
  'personaTabs.content2Feature1':
    'Escaparate de propiedad orientado al destino',
  'personaTabs.content2Feature2': 'Engagement inmersivo previo a la llegada',
  'personaTabs.content3Title': 'Vende el estilo de vida, no solo la propiedad.',
  'personaTabs.content3Desc':
    'Map y Spark ofrecen a tus compradores una vista inmersiva del destino en el que están invirtiendo — senderos, restaurantes, cultura, experiencias. El entorno se convierte en parte del argumento.',
  'personaTabs.content3Feature0': 'Cartografía inmersiva de destino',
  'personaTabs.content3Feature1':
    'Experiencia de comprador orientada al lifestyle',
  'personaTabs.content3Feature2': 'El entorno como argumento de venta',

  // Use Cases
  'useCases.sectionTitle': 'Descúbrelo en el mundo real.',
  'useCases.case0Label': 'Oficina de turismo',
  'useCases.case0Title': 'Visit Beni Mellal-Khénifra',
  'useCases.case0Desc':
    'Una oficina de turismo regional en Marruecos desplegó Trippp Map y Spark para digitalizar un destino previamente poco promocionado — ofreciendo a los visitantes una ventana interactiva y multilingüe a las montañas, valles y cultura de la región.',
  'useCases.case1Label': 'Oficina de turismo',
  'useCases.case1Title': 'Visit Draa-Tafilalet',
  'useCases.case1Desc':
    'La puerta de entrada al Sahara en Marruecos ahora tiene un mapa interactivo que cubre su vasto territorio — ciudades, oasis, kasbahs y rutas de trekking, todo completamente multilingüe.',
  'useCases.case2Label': 'DMC',
  'useCases.case2Title': 'Lumi Morocco',
  'useCases.case2Desc':
    'Un DMC marroquí desplegó Trippp Ops para ofrecer a los viajeros de sus clientes internacionales una experiencia de viaje completamente con marca — programa, extras, documentos y comunicación en tiempo real, todo bajo la marca Lumi.',
  'useCases.explore': 'Explorar',
  'useCases.comingSoon': 'Próximamente',

  // How It Works
  'howItWorks.title': 'Cómo funciona',
  'howItWorks.subtitle':
    'De la primera conversación al despliegue completo en semanas, no meses.',
  'howItWorks.step0Title': 'Consultar',
  'howItWorks.step0Desc':
    'Analizamos tus necesidades operativas y objetivos únicos.',
  'howItWorks.step1Title': 'Configurar',
  'howItWorks.step1Desc':
    'Selecciona y personaliza los módulos que se adaptan a tu negocio.',
  'howItWorks.step2Title': 'Desplegar',
  'howItWorks.step2Desc': 'Lanza tu plataforma con marca y empieza a escalar.',

  // Pricing Teaser
  'pricingTeaser.title': 'Precios transparentes. Sin sorpresas.',
  'pricingTeaser.desc':
    'Trippp se cobra por producto, por despliegue. Licencias anuales, configuración única y un modelo por operación para Trippp Ops. Sin tarifas ocultas, sin cajas negras enterprise.',
  'pricingTeaser.cta': 'Ver todos los precios',

  // Final CTA
  'finalCTA.titlePart1': 'Tecnología turística construida para quienes ',
  'finalCTA.titleHighlight': 'construyen el destino',
  'finalCTA.desc':
    'No adaptada de un SaaS genérico. Construida desde cero para cómo funciona realmente el turismo.',
  'finalCTA.cta': 'Reservar una llamada de 30 minutos',

  // Footer
  'footer.tagline':
    'La plataforma tecnológica modular para el turismo que impulsa el viaje completo.',
  'footer.products': 'Productos',
  'footer.company': 'Empresa',
  'footer.aboutUs': 'Nosotros',
  'footer.careers': 'Carreras',
  'footer.blog': 'Blog',
  'footer.contact': 'Contacto',
  'footer.language': 'Idioma',
  'footer.copyright':
    '© {year} Trippp Technologies. Todos los derechos reservados.',
  'footer.privacy': 'Política de privacidad',
  'footer.terms': 'Términos de servicio',

  // Pricing Page
  'pricing.heroTitle': 'Precios transparentes. ',
  'pricing.heroTitleHighlight': 'Sin sorpresas.',
  'pricing.heroDesc':
    'Cada producto tiene una licencia anual clara. Sin tarifas ocultas, sin cajas negras enterprise. Elige lo que necesitas, sabe lo que pagas.',
  'pricing.mapTitle': 'Trippp Map',
  'pricing.mapSubtitle': 'Licencia anual + configuración única',
  'pricing.sparkTitle': 'Trippp Spark',
  'pricing.sparkSubtitle': 'Licencia anual + configuración única',
  'pricing.opsTitle': 'Trippp Ops',
  'pricing.opsSubtitle': 'Dos opciones. Escala cuando estés listo.',
  'pricing.tier': 'Nivel',
  'pricing.annualLicense': 'Licencia anual',
  'pricing.setup': 'Configuración (única)',
  'pricing.city': 'Ciudad',
  'pricing.region': 'Región',
  'pricing.country': 'País / Multi-región',
  'pricing.hotelProperty': 'Hotel / Propiedad',
  'pricing.mapIncludes':
    'Incluye alojamiento, acceso CMS, API, actualizaciones de plataforma y soporte multilingüe.',
  'pricing.dmoTourismBoard': 'OGD / Oficina de turismo',
  'pricing.agency': 'Agencia',
  'pricing.sparkIncludes':
    'Incluye alojamiento, configuración en marca blanca y actualizaciones de la plataforma.',
  'pricing.platformLicense': 'Licencia de plataforma',
  'pricing.perOperation': 'Por operación',
  'pricing.singleOperation': 'Operación única',
  'pricing.noCommitment': 'Sin compromiso',
  'pricing.oneTimeLabel': '(pago único)',
  'pricing.year': '/ año',
  'pricing.op': '/ op',
  'pricing.platformLicenseDesc':
    'Acceso completo de administrador, CMS, kit de marca, cuentas de personal ilimitadas.',
  'pricing.perOperationDesc':
    'Lineal. Sin niveles. Sin compromisos de volumen. Cada operación puede tener marca blanca de forma independiente.',
  'pricing.singleOperationDesc':
    'Una operación, un precio. Sin licencia anual, sin compromiso. Ideal para un primer despliegue o un viaje puntual.',
  'pricing.exampleNote':
    'Licencia anual: una agencia que gestiona 10 operaciones/año paga 4.800 € + 5.000 € = 9.800 €. O prueba una operación única por 3.000 € sin compromiso.',
  'pricing.bundleNote': '¿Usas más de un producto Trippp? ',
  'pricing.bundleHighlight': 'Pregúntanos por precios de paquete.',
  'pricing.faqTitle': 'Preguntas frecuentes',
  'pricing.faq0Q': '¿Qué incluye la licencia anual?',
  'pricing.faq0A':
    'Alojamiento, actualizaciones de plataforma, acceso CMS, acceso API, configuración en marca blanca y soporte multilingüe. Todo lo que necesitas para operar el producto.',
  'pricing.faq1Q': '¿Cuánto tarda el despliegue?',
  'pricing.faq1A':
    'Normalmente de 2 a 4 semanas desde el inicio hasta la puesta en marcha, dependiendo de la disponibilidad del contenido y el alcance.',
  'pricing.faq2Q': '¿Puedo empezar con un producto y añadir otros después?',
  'pricing.faq2A':
    'Sí. Cada producto es independiente. Añade Map, Spark o Trippp Ops cuando estés listo.',
  'pricing.faq3Q': '¿Hay un período de compromiso?',
  'pricing.faq3A':
    'Las licencias son anuales. No se requiere compromiso plurianual.',
  'pricing.ctaTitle': 'Conoce el precio. Ve el producto. ',
  'pricing.ctaHighlight': 'Decide con claridad.',
  'pricing.ctaCta': 'Reservar una llamada de 30 minutos',

  // About Page
  'about.heroTitle': 'Construimos tecnología para quienes ',
  'about.heroTitleHighlight': 'construyen destinos.',
  'about.heroDesc':
    'Trippp nació de despliegues reales en destinos reales. No de un pitch deck — del terreno.',
  'about.originTitle': 'De dónde viene Trippp.',
  'about.originP1':
    'Trippp empezó como un conjunto de herramientas construidas para oficinas de turismo que necesitaban infraestructura digital real — no otro sitio web de plantilla, no otro folleto PDF.',
  'about.originP2':
    'Mapas interactivos, experiencias de descubrimiento cinematográficas y plataformas operativas fueron diseñados, desplegados y probados en destinos reales antes de que Trippp se convirtiera en una empresa de producto.',
  'about.originP3':
    'Cada funcionalidad existe porque un cliente la necesitó en el mundo real.',
  'about.beliefsTitle': 'Tres cosas que defendemos.',
  'about.belief0Title': 'Construido para el turismo, no adaptado.',
  'about.belief0Desc':
    'Las herramientas SaaS genéricas obligan a los profesionales del turismo a adaptar su flujo de trabajo. Trippp fue diseñado desde el primer día en torno a cómo realmente operan destinos, agencias y hoteles.',
  'about.belief1Title': 'Modular por diseño.',
  'about.belief1Desc':
    'Nadie necesita todo el primer día. Elige un producto, añade más cuando tenga sentido. Sin paquetes forzados, sin paquetes inflados.',
  'about.belief2Title': 'Marca blanca por defecto.',
  'about.belief2Desc':
    'Tu marca, tu dominio, tu identidad. Trippp desaparece detrás del nombre que elijas poner al frente.',
  'about.deployedTitle': 'Desplegado. En vivo. Funcionando.',
  'about.deployment0Title': 'Visit Beni Mellal-Khénifra',
  'about.deployment0Desc':
    'Mapa interactivo regional y descubrimiento cinematográfico.',
  'about.deployment1Title': 'Visit Draa-Tafilalet',
  'about.deployment1Desc':
    'Cartografía de un vasto territorio, completamente multilingüe.',
  'about.deployment2Title': 'Lumi Morocco',
  'about.deployment2Desc':
    'App para viajeros en marca blanca y panel de operaciones.',
  'about.seeItLive': 'Ver en vivo',
  'about.ctaTitle': '¿Quieres ver lo que Trippp puede hacer por ',
  'about.ctaHighlight': 'tu destino?',
  'about.ctaCta': 'Reservar una llamada de 30 minutos',

  // Contact Page
  'contact.heroTitle': 'Hablemos ',
  'contact.heroTitleHighlight': 'juntos.',
  'contact.heroDesc':
    '¿Tienes una pregunta, una necesidad específica o simplemente quieres saber más? Escríbenos directamente.',
  'contact.nameLabel': 'Nombre',
  'contact.namePlaceholder': 'María García',
  'contact.emailLabel': 'Email',
  'contact.emailPlaceholder': 'maria@ejemplo.com',
  'contact.companyLabel': 'Empresa',
  'contact.companyPlaceholder': 'Nombre de la empresa',
  'contact.roleLabel': 'Rol',
  'contact.roleSelectRole': 'Seleccionar rol...',
  'contact.roleDmo': 'OGD y Oficina de turismo',
  'contact.roleAgency': 'DMC y Agencia de viaje',
  'contact.roleHotel': 'Hotel y Resort',
  'contact.roleRealestate': 'Promotor inmobiliario',
  'contact.roleOther': 'Otro',
  'contact.messageLabel': 'Mensaje',
  'contact.messagePlaceholder': '¿Cómo podemos ayudarte?',
  'contact.sendMessage': 'Enviar mensaje',
  'contact.responseTime': 'Normalmente respondemos en 24 horas.',
  'contact.demoTitle': '¿Prefieres ver el producto en vivo?',
  'contact.demoDesc':
    'Sin diapositivas. Sin pitch deck. Te mostramos el producto real funcionando en destinos reales.',
  'contact.demoCta': 'Reservar una llamada de 30 minutos →',
  'contact.faqTitle': 'Preguntas ',
  'contact.faqHighlight': 'frecuentes',
  'contact.faq0Q': '¿Qué pasa durante la demo?',
  'contact.faq0A':
    'Te mostramos el producto en vivo — Map, Spark o Trippp Ops según tus necesidades — funcionando en despliegues reales de destinos. Sin maquetas.',
  'contact.faq1Q': '¿Necesito preparar algo?',
  'contact.faq1A':
    'No. Solo trae tus preguntas. Si quieres que nos centremos en un producto específico, menciónalo al reservar.',
  'contact.faq2Q': '¿Es una llamada de ventas?',
  'contact.faq2A':
    'Es una presentación de producto. Verás exactamente lo que obtendrías. Los precios están en nuestro sitio web — sin sorpresas.',

  // Trippp Map Page
  'tripppMap.badge': 'Trippp Map',
  'tripppMap.heroTitle': 'Cada punto de interés. Cada sendero. Cada historia. ',
  'tripppMap.heroTitleHighlight': 'Un solo mapa.',
  'tripppMap.heroDesc':
    'Trippp Map es un mapa interactivo de destino en marca blanca, impulsado por un CMS dedicado. Despliégalo para una ciudad, una región o un país entero — completamente con tu marca, multilingüe y listo en semanas.',
  'tripppMap.bookDemo': 'Reservar una demo',
  'tripppMap.seeItLive': 'Ver en vivo',
  'tripppMap.featuresTitle':
    'Todo lo que un destino necesita en una sola plataforma.',
  'tripppMap.feature0Title': 'Mapa interactivo',
  'tripppMap.feature0Desc':
    'Un mapa completamente navegable con estilo personalizado, puntos de interés filtrables y experiencia móvil fluida.',
  'tripppMap.feature1Title': 'Itinerarios seleccionados',
  'tripppMap.feature1Desc':
    'Rutas de viaje preconstruidas que guían a los visitantes por tu destino día a día.',
  'tripppMap.feature2Title': 'Módulo de senderismo y rutas',
  'tripppMap.feature2Desc':
    'Rutas GPS con desnivel, distancia, dificultad y rutas descargables.',
  'tripppMap.feature3Title': 'Contenido multilingüe',
  'tripppMap.feature3Desc':
    'Cada contenido traducible al idioma que tu audiencia necesite — impulsado por IA.',
  'tripppMap.feature4Title': 'CMS dedicado',
  'tripppMap.feature4Desc':
    'Un back-office construido específicamente para el turismo — gestiona lugares, etiquetas, tours, ofertas, artículos y medios desde un solo panel.',
  'tripppMap.feature5Title': 'Progressive Web App',
  'tripppMap.feature5Desc':
    'Instalable en cualquier teléfono. Funciona offline. Envía notificaciones. Sin necesidad de app store.',
  'tripppMap.targetsTitle': 'Construido para destinos de cualquier escala.',
  'tripppMap.target0Title': 'Ciudad',
  'tripppMap.target0Desc':
    'Un municipio o destino urbano que busca digitalizar su experiencia de visitante.',
  'tripppMap.target1Title': 'Región',
  'tripppMap.target1Desc':
    'Una provincia, gobernación o territorio multi-ciudad con atracciones diversas para organizar y promover.',
  'tripppMap.target2Title': 'País',
  'tripppMap.target2Desc':
    'Un organismo nacional de turismo desplegando un mapa digital unificado en múltiples regiones.',
  'tripppMap.target3Title': 'Hotel / Propiedad',
  'tripppMap.target3Desc':
    'Un resort u hotel mostrando los alrededores y experiencias locales disponibles para los huéspedes.',
  'tripppMap.deploymentsTitle': 'Trippp Map en el mundo real.',
  'tripppMap.deployment0Title': 'Visit Beni Mellal-Khénifra',
  'tripppMap.deployment0Desc':
    'Una oficina de turismo regional en Marruecos que cubre montañas, cascadas, valles y ciudades históricas. Mapa desplegado con CMS completo, contenido multilingüe, itinerarios, rutas de senderismo y ofertas seleccionadas.',
  'tripppMap.deployment1Title': 'Visit Draa-Tafilalet',
  'tripppMap.deployment1Desc':
    'La puerta de entrada al Sahara en Marruecos. Mapa interactivo que abarca un vasto territorio de oasis, kasbahs, rutas desérticas y senderos de trekking — todo completamente multilingüe.',
  'tripppMap.exploreTheMap': 'Explorar el mapa',
  'tripppMap.techTitle': 'Bajo el capó.',
  'tripppMap.tech0':
    'Arquitectura API REST — cada dato accesible a través de endpoints documentados',
  'tripppMap.tech1': 'Mapbox GL JS con estilo cartográfico personalizado',
  'tripppMap.tech2': 'Medios alojados en AWS con distribución CDN',
  'tripppMap.tech3': 'Contenido MongoDB con sincronización CMS en tiempo real',
  'tripppMap.tech4': 'Documentación Swagger/OpenAPI incluida',
  'tripppMap.tech5': 'Marca blanca: tu dominio, tu logo, tus colores',
  'tripppMap.ctaTitle': '¿Listo para poner tu destino ',
  'tripppMap.ctaHighlight': 'en el mapa?',
  'tripppMap.ctaCta': 'Reservar una llamada de 30 minutos',

  // Trippp Spark Page
  'tripppSpark.badge': 'Trippp Spark',
  'tripppSpark.heroTitle': 'Antes de buscar. Antes de reservar. ',
  'tripppSpark.heroTitleHighlight': 'Sienten.',
  'tripppSpark.heroDesc':
    'Trippp Spark es una experiencia de descubrimiento cinematográfica basada en emociones. Los viajeros no filtran por fecha o precio — deslizan por historias visuales hasta que un destino les habla. Personalízala con tu marca e intégrala en cualquier lugar.',
  'tripppSpark.bookDemo': 'Reservar una demo',
  'tripppSpark.experienceItLive': 'Vivir la experiencia en vivo',
  'tripppSpark.howItWorksTitle':
    'Descubrimiento a través de la emoción, no la logística.',
  'tripppSpark.step0Title': 'Sentir',
  'tripppSpark.step0Desc':
    'Los visitantes llegan a una experiencia visual inmersiva a pantalla completa. Sin menús. Sin barras de búsqueda. Solo imágenes y emoción.',
  'tripppSpark.step1Title': 'Explorar',
  'tripppSpark.step1Desc':
    'Deslizan, hacen scroll y tocan categorías visuales — aventura, serenidad, cultura, vida nocturna — descubriendo lugares por lo que sienten, no por dónde están.',
  'tripppSpark.step2Title': 'Conectar',
  'tripppSpark.step2Desc':
    'Cada experiencia enlaza con contenido detallado — lugares, historias, info práctica — conectando emoción con acción.',
  'tripppSpark.targetsTitle':
    'Spark vive donde las primeras impresiones importan.',
  'tripppSpark.target0Title': 'OGD / Oficina de turismo',
  'tripppSpark.target0Desc':
    'Despliega Spark como la puerta emocional de tu destino. Una experiencia cinematográfica completa que cubre todo lo que tu región ofrece, completamente con tu marca.',
  'tripppSpark.target1Title': 'Hotel / Resort',
  'tripppSpark.target1Desc':
    'Integra Spark en tu sitio web. Deja que los huéspedes potenciales sientan la propiedad y sus alrededores antes de verificar disponibilidad.',
  'tripppSpark.target2Title': 'Agencia',
  'tripppSpark.target2Desc':
    'Añade Spark como página de experiencia en tus sitios para clientes. Diferencia tu marca con una capa de descubrimiento que ningún competidor tiene.',
  'tripppSpark.deploymentTitle': 'Trippp Spark en el mundo real.',
  'tripppSpark.deployment0Title':
    'Visit Beni Mellal-Khénifra — Modo Inspiración',
  'tripppSpark.deployment0Desc':
    'La oficina de turismo regional desplegó Spark junto a Map para crear una experiencia dual: los visitantes pueden explorar lógicamente a través de Map o emocionalmente a través de Spark. Ambas plataformas comparten la misma API y contenido CMS.',
  'tripppSpark.experienceIt': 'Vivir la experiencia',
  'tripppSpark.differentTitle':
    'No es una galería. No es un slider. Un nuevo formato.',
  'tripppSpark.diff0':
    'Pantalla completa, cinematográfico primero. Diseñado para sentirse, no escanearse.',
  'tripppSpark.diff1':
    'Contenido impulsado por el mismo CMS y API que Trippp Map. Una sola fuente de verdad.',
  'tripppSpark.diff2':
    'Marca blanca: tu marca, tu dominio, tu identidad visual.',
  'tripppSpark.diff3':
    'Integrable como página independiente o en cualquier sitio web existente.',
  'tripppSpark.ctaTitle': 'Dale a tu audiencia una razón para soñar ',
  'tripppSpark.ctaHighlight': 'antes de planificar.',
  'tripppSpark.ctaCta': 'Reservar una llamada de 30 minutos',

  // Trippp Ops Page
  'tripppOps.badge': 'Trippp Ops',
  'tripppOps.heroTitle': 'Una app para el viajero. Un panel para la agencia. ',
  'tripppOps.heroTitleHighlight': 'Claridad total para todos.',
  'tripppOps.heroDesc':
    'Trippp Ops es una app para viajeros y plataforma operativa en marca blanca. Para cada operación, tus viajeros obtienen su programa completo, marketplace de extras, documentos y contactos de emergencia. Tu equipo obtiene visibilidad de reservas, seguimiento de comisiones y mensajería broadcast. Con marca diferente para cada viaje si lo necesitas.',
  'tripppOps.bookDemo': 'Reservar una demo',
  'tripppOps.seeHowItWorks': 'Ver cómo funciona',
  'tripppOps.travelerTitle': 'Lo que ven tus viajeros.',
  'tripppOps.traveler0Title': 'Programa del viaje',
  'tripppOps.traveler0Desc':
    'Itinerario día a día accesible mediante un código de viaje único. Sin necesidad de descargar app.',
  'tripppOps.traveler1Title': 'Marketplace de extras',
  'tripppOps.traveler1Desc':
    'Traslados, excursiones, spa, restaurantes — los viajeros navegan y reservan servicios opcionales directamente.',
  'tripppOps.traveler2Title': 'Biblioteca de documentos',
  'tripppOps.traveler2Desc':
    'Vouchers, billetes, seguro de viaje, info práctica — todo en un solo lugar.',
  'tripppOps.traveler3Title': 'Contactos de emergencia',
  'tripppOps.traveler3Desc':
    'Números de emergencia locales, contactos de agencia, info del hotel — siempre accesibles.',
  'tripppOps.traveler4Title': 'Compartir medios',
  'tripppOps.traveler4Desc':
    'Fotos y recuerdos compartidos dentro del grupo de viaje.',
  'tripppOps.traveler5Title': 'Multilingüe',
  'tripppOps.traveler5Desc':
    'Disponible en cualquier idioma — traducción impulsada por IA para cada audiencia.',
  'tripppOps.agencyTitle': 'Lo que tu equipo controla.',
  'tripppOps.agency0Title': 'Creación de viaje',
  'tripppOps.agency0Desc':
    'Crea una nueva operación en minutos. Define el programa, configura los extras disponibles, asigna participantes.',
  'tripppOps.agency1Title': 'Marca blanca por operación',
  'tripppOps.agency1Desc':
    'Cada viaje puede llevar una marca diferente — la tuya, la de tu socio o la de tu cliente. Logo, colores, dominio.',
  'tripppOps.agency2Title': 'Seguimiento de reservas y comisiones',
  'tripppOps.agency2Desc':
    'Ve cada extra reservado, cada servicio vendido. Sigue las comisiones en tiempo real en todas las operaciones.',
  'tripppOps.agency3Title': 'Gestión de participantes',
  'tripppOps.agency3Desc':
    'Añade viajeros, gestiona accesos, monitoriza el engagement por operación.',
  'tripppOps.agency4Title': 'Mensajería broadcast',
  'tripppOps.agency4Desc':
    'Envía actualizaciones a todos los viajeros de una operación vía notificaciones WhatsApp.',
  'tripppOps.mandatesTitle': 'La herramienta que gana mandatos.',
  'tripppOps.scenario0':
    'Una agencia brasileña manda Trippp Ops a su proveedor DMC marroquí. Cada operación en Marruecos pasa por la plataforma — en marca blanca bajo la marca de la agencia brasileña. La agencia tiene visibilidad completa sobre los extras vendidos y las comisiones ganadas, incluso a 10.000 km de distancia.',
  'tripppOps.scenario1':
    'Un DMC marroquí propone a una agencia internacional un viaje incentivo de 200 personas. ¿Su diferenciador? Una app para viajeros con marca, con un marketplace de servicios completo, acceso a documentos y actualizaciones en tiempo real. La agencia lo elige frente a tres competidores que ofrecían hojas de cálculo y PDFs.',
  'tripppOps.deploymentTitle': 'Trippp Ops en el mundo real.',
  'tripppOps.deployment0Title': 'Lumi Morocco',
  'tripppOps.deployment0Desc':
    'Un DMC marroquí desplegó Trippp Ops para servir a sus clientes agencias internacionales. Los viajeros acceden a su viaje completo bajo la marca Lumi — programa, extras, documentos, contactos de emergencia — mientras el equipo Lumi gestiona reservas, sigue comisiones y comunica en tiempo real.',
  'tripppOps.learnMore': 'Saber más',
  'tripppOps.pricingTitle': 'Precios simples. Escala con tus operaciones.',
  'tripppOps.platformLicense': 'Licencia de plataforma',
  'tripppOps.perOperation': 'Por operación',
  'tripppOps.noPriceNote':
    'Sin tarifas ocultas. Sin compromisos de volumen. Pagas cuando operas.',
  'tripppOps.seeFullPricing': 'Ver todos los precios',
  'tripppOps.ctaTitle': 'Deja de gestionar viajes en hojas de cálculo. ',
  'tripppOps.ctaHighlight': 'Empieza a dirigir operaciones.',
  'tripppOps.ctaCta': 'Reservar una llamada de 30 minutos',

  // Use Case DMO Page
  'useCaseDMO.badge': 'OGD y Oficinas de turismo',
  'useCaseDMO.heroTitle': 'Tu destino merece más que un ',
  'useCaseDMO.heroTitleHighlight': 'sitio web de folleto.',
  'useCaseDMO.heroDesc':
    'Trippp ofrece a las oficinas de turismo una plataforma digital modular: un mapa interactivo, una experiencia de descubrimiento cinematográfica y un sistema de gestión de contenido completo — todo en marca blanca, multilingüe y desplegable en semanas.',
  'useCaseDMO.bookDemo': 'Reservar una demo',
  'useCaseDMO.challengeTitle': 'Lo que enfrentan las OGD hoy.',
  'useCaseDMO.pain0':
    'Sitios web estáticos que ningún viajero guarda en favoritos.',
  'useCaseDMO.pain1':
    'Contenido disperso entre PDFs, redes sociales y plataformas de terceros que no controlas.',
  'useCaseDMO.pain2':
    'Cero infraestructura digital para competir con destinos que tienen 10 veces tu presupuesto.',
  'useCaseDMO.solutionTitle':
    'Map + Spark: la columna vertebral digital de tu destino.',
  'useCaseDMO.mapDesc':
    'Ofrece a los visitantes un mapa navegable, filtrable y multilingüe de todo lo que tu región ofrece. Gestiona todo el contenido a través de un CMS específico para turismo — lugares, itinerarios, rutas de senderismo, ofertas, artículos.',
  'useCaseDMO.sparkDesc':
    'Crea una primera impresión emocional. Una experiencia cinematográfica y deslizable que hace sentir tu destino a los viajeros antes de que planifiquen. Integrable, personalizable, compartible.',
  'useCaseDMO.sharedNote':
    '"Ambos productos comparten el mismo CMS y API. Un solo esfuerzo de contenido alimenta dos experiencias."',
  'useCaseDMO.deploymentsTitle': 'Despliegues reales.',
  'useCaseDMO.deployment0Title': 'Visit Beni Mellal-Khénifra',
  'useCaseDMO.deployment0Desc':
    'Una oficina de turismo regional en Marruecos desplegó Trippp Map y Spark para digitalizar un destino previamente poco promocionado — ofreciendo a los visitantes una ventana interactiva y multilingüe a las montañas, valles y cultura de la región.',
  'useCaseDMO.deployment1Title': 'Visit Draa-Tafilalet',
  'useCaseDMO.deployment1Desc':
    'La puerta de entrada al Sahara en Marruecos ahora tiene un mapa interactivo que cubre su vasto territorio — ciudades, oasis, kasbahs y rutas de trekking, todo completamente multilingüe.',
  'useCaseDMO.seeItLive': 'Ver en vivo',
  'useCaseDMO.whatYouGetTitle': 'Lo que obtienes.',
  'useCaseDMO.check0': 'Plataforma en marca blanca bajo tu marca de destino',
  'useCaseDMO.check1': 'CMS dedicado construido para contenido turístico',
  'useCaseDMO.check2': 'Multilingüe — cualquier idioma, impulsado por IA',
  'useCaseDMO.check3': 'API REST con documentación pública',
  'useCaseDMO.check4': 'PWA — instalable, funciona offline, sin app store',
  'useCaseDMO.check5':
    'Alojamiento continuo y actualizaciones de plataforma incluidos',
  'useCaseDMO.ctaTitle': 'Pon tu región en el mapa digital. ',
  'useCaseDMO.ctaHighlight': 'Literalmente.',
  'useCaseDMO.ctaCta': 'Reservar una llamada de 30 minutos',

  // Use Case DMC Page
  'useCaseDMC.badge': 'DMC y Agencias de viaje',
  'useCaseDMC.heroTitle':
    'Gestiona operaciones que impresionen a tus clientes y ',
  'useCaseDMC.heroTitleHighlight': 'asegura tus comisiones.',
  'useCaseDMC.heroDesc':
    'Trippp Ops ofrece a tu agencia una app para viajeros en marca blanca y un panel de operaciones para cada viaje. Tus viajeros obtienen una experiencia fluida durante el viaje. Tu equipo obtiene visibilidad completa sobre reservas, extras y comisiones.',
  'useCaseDMC.bookDemo': 'Reservar una demo',
  'useCaseDMC.challengeTitle': 'Lo que enfrentan los DMC hoy.',
  'useCaseDMC.pain0':
    'Gestionar la logística de viajes entre grupos de WhatsApp, emails y documentos compartidos.',
  'useCaseDMC.pain1':
    'Sin visibilidad sobre qué extras compran los viajeros — y sin forma de capturar comisiones.',
  'useCaseDMC.pain2':
    'Perder mandatos internacionales frente a competidores que parecen más profesionales digitalmente.',
  'useCaseDMC.solutionTitle': 'Trippp Ops: una plataforma para cada operación.',
  'useCaseDMC.travelerAppTitle': 'Funciones de la app para viajeros',
  'useCaseDMC.travelerFeature0': 'Programa e itinerario',
  'useCaseDMC.travelerFeature1': 'Marketplace de extras',
  'useCaseDMC.travelerFeature2': 'Biblioteca de documentos',
  'useCaseDMC.travelerFeature3': 'Contactos de emergencia',
  'useCaseDMC.adminDashboardTitle': 'Funciones del panel de administración',
  'useCaseDMC.adminFeature0': 'Creación y gestión de viajes',
  'useCaseDMC.adminFeature1': 'Marca blanca por operación',
  'useCaseDMC.adminFeature2': 'Seguimiento de reservas y comisiones',
  'useCaseDMC.adminFeature3': 'Mensajería broadcast',
  'useCaseDMC.whiteLabelNote':
    '"Cada operación puede ser en marca blanca con una marca diferente — la tuya, la de tu socio o la de la agencia de tu cliente. Misma plataforma, cara diferente."',
  'useCaseDMC.edgeTitle':
    'Gana mandatos. Conserva comisiones. Luce de clase mundial.',
  'useCaseDMC.scenario0':
    'Una agencia brasileña manda Trippp Ops a su proveedor DMC marroquí. Cada operación en Marruecos pasa por la plataforma — en marca blanca bajo la marca de la agencia brasileña. La agencia tiene visibilidad completa sobre los extras vendidos y las comisiones ganadas, incluso a 10.000 km.',
  'useCaseDMC.scenario1':
    'Un DMC marroquí propone a una agencia internacional un viaje incentivo de 200 personas. ¿Su diferenciador? Una app para viajeros con marca, con un marketplace de servicios completo, acceso a documentos y actualizaciones en tiempo real. La agencia lo elige frente a tres competidores que ofrecían hojas de cálculo y PDFs.',
  'useCaseDMC.deploymentTitle': 'Despliegue real.',
  'useCaseDMC.deployment0Title': 'Lumi Morocco',
  'useCaseDMC.deployment0Desc':
    'Un DMC marroquí desplegó Trippp Ops para ofrecer a los viajeros de sus clientes internacionales una experiencia de viaje completamente con marca — programa, extras, documentos y comunicación en tiempo real, todo bajo la marca Lumi.',
  'useCaseDMC.learnMore': 'Saber más',
  'useCaseDMC.pricingTitle': 'Precios simples. Escala con tus operaciones.',
  'useCaseDMC.platformLicense': 'Licencia de plataforma',
  'useCaseDMC.perOperation': 'Por operación',
  'useCaseDMC.seeFullPricing': 'Ver todos los precios',
  'useCaseDMC.ctaTitle':
    'Tu próximo cliente elige entre tú y un competidor que trabaja con hojas de cálculo. ',
  'useCaseDMC.ctaHighlight': 'Hazlo obvio.',
  'useCaseDMC.ctaCta': 'Reservar una llamada de 30 minutos',

  // Use Case Hotels Page
  'useCaseHotels.badge': 'Hoteles y Resorts',
  'useCaseHotels.heroTitle': 'Tus huéspedes quieren explorar. ',
  'useCaseHotels.heroTitleHighlight': 'Dales una razón para empezar contigo.',
  'useCaseHotels.heroDesc':
    'Trippp ofrece a hoteles y resorts dos herramientas para enriquecer la experiencia del huésped: un mapa interactivo del destino circundante y una experiencia de descubrimiento cinematográfica — ambas integrables en tu sitio web, ambas con tu marca.',
  'useCaseHotels.bookDemo': 'Reservar una demo',
  'useCaseHotels.challengeTitle': 'Lo que enfrentan los hoteles hoy.',
  'useCaseHotels.pain0':
    'Un hermoso sitio web de hotel que se detiene en el lobby. Nada sobre lo que te rodea.',
  'useCaseHotels.pain1':
    'Los huéspedes descubren el destino en TripAdvisor o Google — no a través de tu marca.',
  'useCaseHotels.pain2':
    'Sin forma de diferenciarse más allá de fotos de habitaciones y listas de amenidades.',
  'useCaseHotels.solutionTitle': 'La solución Trippp.',
  'useCaseHotels.mapTitle': 'Trippp Map — Nivel Propiedad',
  'useCaseHotels.mapDesc':
    'Un mapa interactivo de tus alrededores. Restaurantes, actividades, sitios culturales, playas, senderos — seleccionados por ti, presentados bajo tu marca. Los huéspedes exploran el destino a través de tu mirada.',
  'useCaseHotels.sparkTitle': 'Trippp Spark — Nivel Propiedad',
  'useCaseHotels.sparkDesc':
    'Una página cinematográfica en tu sitio web que permite a los futuros huéspedes sentir el destino emocionalmente. No una galería de fotos — una experiencia de descubrimiento a pantalla completa, deslizable y basada en emociones.',
  'useCaseHotels.fitsTitle': 'Integrado sin costuras. Con marca completa.',
  'useCaseHotels.fit0':
    'Spark se convierte en una página de tu sitio — "Explorar el destino" — que ningún hotel competidor tiene.',
  'useCaseHotels.fit1':
    'Map vive como una guía interactiva que los huéspedes pueden consultar antes y durante su estancia.',
  'useCaseHotels.fit2':
    'Ambos llevan el logo, colores y dominio de tu hotel. Los visitantes nunca abandonan tu marca.',
  'useCaseHotels.ctaTitle': 'Deja de vender habitaciones. ',
  'useCaseHotels.ctaHighlight':
    'Empieza a vender la experiencia que las rodea.',
  'useCaseHotels.ctaCta': 'Reservar una llamada de 30 minutos',

  // Use Case Real Estate Page
  'useCaseRealEstate.badge': 'Inmobiliaria y Lifestyle',
  'useCaseRealEstate.heroTitle': 'No vendes metros cuadrados. ',
  'useCaseRealEstate.heroTitleHighlight': 'Vendes un estilo de vida.',
  'useCaseRealEstate.heroDesc':
    'Trippp ofrece a promotores inmobiliarios y lifestyle herramientas para mostrar el destino alrededor de la propiedad — senderos, restaurantes, cultura, experiencias — convirtiendo la ubicación de una línea en la atracción principal.',
  'useCaseRealEstate.bookDemo': 'Reservar una demo',
  'useCaseRealEstate.challengeTitle': 'Lo que enfrentan los promotores hoy.',
  'useCaseRealEstate.pain0':
    'Los compradores ven planos y renders. No sienten el estilo de vida.',
  'useCaseRealEstate.pain1':
    'La ubicación se menciona como un punto, nunca como una experiencia.',
  'useCaseRealEstate.pain2':
    'Los desarrollos competidores en la misma zona se ven todos iguales en papel.',
  'useCaseRealEstate.solutionTitle': 'La solución Trippp.',
  'useCaseRealEstate.mapDesc':
    'Un mapa interactivo de los alrededores — restaurantes, actividades al aire libre, sitios culturales, escuelas, transporte. Los compradores potenciales exploran el barrio a través de una mirada seleccionada y con marca.',
  'useCaseRealEstate.sparkDesc':
    'Una experiencia cinematográfica que hace sentir el estilo de vida a los compradores antes de visitar el showroom. Los senderos de montaña al amanecer. Los restaurantes costeros al atardecer. La escena cultural los fines de semana.',
  'useCaseRealEstate.impactTitle': 'Haz del entorno parte del argumento.',
  'useCaseRealEstate.impact0':
    'Cuando dos desarrollos ofrecen especificaciones similares a precios similares, el que vende el estilo de vida gana. Trippp hace el estilo de vida tangible.',
  'useCaseRealEstate.impact1':
    'Integra Map y Spark en tu sitio de ventas, tus folletos, tus pantallas de showroom. Cada punto de contacto se convierte en un argumento inmersivo.',
  'useCaseRealEstate.ctaTitle': 'Vende la vista. Vende el sendero. ',
  'useCaseRealEstate.ctaHighlight': 'Vende el sábado por la mañana.',
  'useCaseRealEstate.ctaCta': 'Reservar una llamada de 30 minutos',
}
